import React, { useEffect, useState, useRef } from 'react';
import { useInView } from 'react-intersection-observer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';

import '../styles/Herosection.css';


import slide1 from '../assets/banner6A.jpg';
import slide2 from '../assets/wind4A.jpg';
import slide3 from '../assets/banner7A.jpg';
import slide4 from '../assets/installation6A.jpeg';
import slide5 from '../assets/oil&gas1A.png';
import slide6 from '../assets/solar10A.jpeg';
import slide7 from '../assets/elec2A.jpg';

import img11 from '../assets/ic1.png';
import img12 from '../assets/ic6.png';
import img13 from '../assets/ic3.png';
import img14 from '../assets/ic4.png';
import img15 from '../assets/ic5.png';
import img16 from '../assets/ic8.png';

const images = [slide1, slide2, slide3, slide4, slide5, slide6, slide7];

const words = [
  'ENGINEERING DESIGN',
  'TESTING & COMMISSIONING',
  'EQUIPMENT RENTAL',
  'SOLAR ENERGY',
  'OPERATION & MAINTANENCE',
  'TRANSFORMER OIL FILTRATION',
  'MANPOWER'
];

const HeroSection = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({ duration: 1000 });
  }, []);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const wordRefs = useRef([]);

  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });

  useEffect(() => {
    const imageInterval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(imageInterval);
  }, []);

  useEffect(() => {
    wordRefs.current.forEach((ref, index) => {
      if (ref) ref.style.opacity = index === currentWordIndex ? 1 : 0;
    });

    const wordInterval = setInterval(() => {
      const cw = wordRefs.current[currentWordIndex];
      const nextIndex = (currentWordIndex + 1) % words.length;
      const nw = wordRefs.current[nextIndex];

      const cwLetters = cw.children;
      const nwLetters = nw.children;

      for (let i = 0; i < cwLetters.length; i++) {
        cwLetters[i].className = 'letter out';
      }

      for (let i = 0; i < nwLetters.length; i++) {
        nwLetters[i].className = 'letter behind';
        nw.style.opacity = 1;
        setTimeout(() => {
          nwLetters[i].className = 'letter in';
        }, 340 + i * 80);
      }

      setCurrentWordIndex(nextIndex);
    }, 4000);

    return () => clearInterval(wordInterval);
  }, [currentWordIndex]);

  const splitWord = (word, index) => {
    return (
      <span
        key={index}
        className="word"
        ref={(el) => (wordRefs.current[index] = el)}
        style={{ opacity: index === 0 ? 1 : 0 }}
      >
        {word.split('').map((letter, i) => (
          <span key={i} className="letter in">
            {letter === ' ' ? '\u00A0' : letter}
          </span>
        ))}
      </span>
    );
  };

  const services = [
    {
      icon: img11,
      title: 'EPC Contracting',
      path: '/services/epcpage'
    },
    {
      icon: img12,
      title: 'Equipment Rental',
      path: '/services/equipmentrentalpg'
    },
    {
      icon: img13,
      title: 'Transformer Oil Filtration',
      path: '/services/oilfiltrationpg'
    },
    {
      icon: img14,
      title: 'Renewable Energy',
      path: '/services/Renewablepg'
    },
    {
      icon: img15,
      title: 'Operation & Maintenance',
      path: '/services/operationmaintenancepg'
    },
    {
      icon: img16,
      title: 'Cable Laying and Termination',
      path: '/services/cablepg'
    },

  ];

  return (
    <section
      className="hero-section"
      style={{ backgroundImage: `url(${images[currentIndex]})` }}
    >
      <div
        ref={ref}
        className={`hero-content dark-silver-wrapper ${inView ? 'fade-up' : ''}`}
      >
        <h1 className="dark-silver-text dark-silver-text1 shiny-wrapper">
          <span className="h-or">Leading Contracting</span> - Services for Installation, Testing and Commissioning
        </h1>

        <div className="text-animation">
          <p className="dynamic-text">
            {words.map((word, i) => splitWord(word, i))}
          </p>
        </div>
      </div>

      <div className="hero-services-wrapper">
        <div className="hero-services-container">
          {services.map((service, i) => (
            <Link
              to={service.path}
              className="hero-service-box"
              key={i}
              data-aos="fade-up"
              data-aos-delay={i * 100}
            >
              <div className="hero-service-icon">
                <img src={service.icon} alt={service.title} />
              </div>
              <div className="hero-service-text">
                <h3>{service.title}</h3>
                <FaArrowRight className="hero-arrow-icon" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
